<div class="flex flex-col min-h-screen bg-background-light text-slate-800">
  <app-header *ngIf="!isLoginPage"></app-header>
  <router-outlet></router-outlet>
  <app-footer *ngIf="!isLoginPage"></app-footer>
</div>

<div *ngIf="isLoading$ | async"
  class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/30 backdrop-blur-[2px]"
  role="status"
  aria-live="polite"
  aria-label="Loading data">
  <div class="flex min-w-[220px] items-center gap-3 rounded-lg border border-slate-200 bg-white px-5 py-4 text-sm font-semibold text-slate-700 shadow-xl">
    <span class="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-primary"></span>
    <span>Loading data...</span>
  </div>
</div>
